import { themeConfig } from "./ThemeConfig";
import { COMPANY_FEATURES } from "@routebot/constants";

export const isInternationalTheme = () => {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname);
  return themeKey === "routebot";
};

/** phoneApp admin UI (school QR/reports, route times, etc.) — hidden on RouteBot/international theme.
 *  Parent notification settings use PHONE_APP directly and are NOT gated by this helper. */
export const isPhoneAppAdminUiEnabled = (companyFeatures = {}) =>
  !!companyFeatures[COMPANY_FEATURES.PHONE_APP] && !isInternationalTheme();

const getThemeKeyFromHostname = (hostname) => {
  if (process.env.REACT_APP_FORCE_SERVISTESIN_UI === "1") {
    return "servistesin";
  }

  return Object.keys(themeConfig).find((key) => hostname.includes(key)) || process.env.REACT_APP_DEFAULT_THEME;
};

export function getThemeName() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.name;
}

export function getThemeDocsAdminUrl() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.docsAdminUrl;
}

export function getThemeDocsAppUrl() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.docsAppUrl;
}

export function getThemeLandingPageUrl() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.landingPageUrl;
}

export function getThemeEmail() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.email;
}

export function getThemeSupportEmail() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];
  return theme.supportEmail || theme.email;
}

export function setThemeVariables() {
  const hostname = window.location.hostname;
  const themeKey = getThemeKeyFromHostname(hostname) || process.env.REACT_APP_DEFAULT_THEME;
  const theme = themeConfig[themeKey];

  const root = document.documentElement;
  root.style.setProperty("--color-primary-surface", theme.colors.primarySurface);
  root.style.setProperty("--color-gray-surface", theme.colors.graySurface);
  root.style.setProperty("--color-gray-selected", theme.colors.graySelected);
  root.style.setProperty("--color-gray-hover", theme.colors.grayHover);

  root.style.setProperty("--color-button-primary-background", theme.colors.buttonPrimaryBackground);
  root.style.setProperty("--color-button-primary-text", theme.colors.buttonPrimaryText);
  root.style.setProperty("--color-button-primary-hover-background", theme.colors.buttonPrimaryHoverBackground);

  root.style.setProperty("--color-button-primary-inverse-background", theme.colors.buttonPrimaryInverseBackground);
  root.style.setProperty("--color-button-primary-inverse-text", theme.colors.buttonPrimaryInverseText);
  root.style.setProperty(
    "--color-button-primary-inverse-hover-background",
    theme.colors.buttonPrimaryInverseHoverBackground
  );

  root.style.setProperty("--color-button-primary-danger-background", theme.colors.buttonPrimaryDangerBackground);
  root.style.setProperty("--color-button-primary-danger-text", theme.colors.buttonPrimaryDangerText);
  root.style.setProperty(
    "--color-button-primary-danger-hover-background",
    theme.colors.buttonPrimaryDangerHoverBackground
  );

  root.style.setProperty("--color-button-primary-disabled-background", theme.colors.buttonPrimaryDisabledBackground);
  root.style.setProperty("--color-button-primary-disabled-text", theme.colors.buttonPrimaryDisabledText);

  root.style.setProperty("--color-button-selected-background", theme.colors.buttonSelectedBackground);
  root.style.setProperty("--color-button-selected-text", theme.colors.buttonSelectedText);

  root.style.setProperty("--color-link", theme.colors.link);

  root.style.setProperty("--theme", theme.theme);
  root.style.setProperty("--logo-url", `url(${theme.logo})`);
  root.style.setProperty("--text-color", theme.theme === "dark" ? "#fff" : "#111");

  // Favicon
  const setFavicon = (url) => {
    const oldLinks = document.querySelectorAll("link[rel='icon']");
    oldLinks.forEach((el) => el.parentNode.removeChild(el));

    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.type = "image/x-icon";
    newLink.href = url + "?v=" + new Date().getTime(); // cache bust
    document.head.appendChild(newLink);
  };
  setFavicon(theme.favicon);

  document.title = theme.name;
}
